/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*********************************!*\
  !*** ./src/assets/js/header.js ***!
  \*********************************/
var oberservProductCard = function oberservProductCard(type) {
  var productCard = document.querySelector('.top-product-card');

  if (productCard) {
    if (type == "up") {
      productCard.classList.add('card-up');
      productCard.classList.remove('card-down');
    } else if (type == "down") {
      productCard.classList.add('card-down');
      productCard.classList.remove('card-up');
    } else {
      productCard.classList.remove('card-down');
      productCard.classList.remove('card-up');
    }
  }
};

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var header = document.querySelector('header');
    var prevScrollPos = window.pageYOffset;
    var bannerTitleTop = null;
    var currentScroll = window.pageYOffset;
    var heroSectionBottom = null;
    var gap = 5;
    var headerLogo = header.querySelector('.main-logo');
    var bannerTitle = document.querySelector('.hero-banner-section__title');
    var heroSection = document.querySelector('.hero-banner-section');

    if (heroSection) {
      heroSectionBottom = heroSection.getBoundingClientRect().bottom;
    }

    if (bannerTitle) {
      if (window.innerWidth <= 768) {
        bannerTitleTop = bannerTitle.getBoundingClientRect().bottom - 72;
      } else {
        bannerTitleTop = bannerTitle.getBoundingClientRect().bottom;
      }

      if (bannerTitleTop !== null && window.location.pathname === "/") {
        if (window.innerWidth <= 768) {
          if (currentScroll > bannerTitleTop) {
            headerLogo.classList.add('show');
          } else {
            headerLogo.classList.remove('show');
          }
        }
      }
    }

    window.onscroll = function () {
      var currentScrollPos = window.pageYOffset;

      if (bannerTitleTop !== null && window.location.pathname === "/") {
        if (window.innerWidth <= 768) {
          if (currentScrollPos > bannerTitleTop) {
            headerLogo.classList.add('show');
          } else {
            headerLogo.classList.remove('show');
          }
        }
      }

      if (currentScrollPos <= 150) {
        oberservProductCard('clear');
      }

      if (currentScrollPos > 0 && prevScrollPos > currentScrollPos) {
        document.getElementById('header').style.top = '0px';

        if (currentScrollPos > 150) {
          oberservProductCard('down');
        }
      } else if (currentScrollPos > 0 && prevScrollPos < currentScrollPos) {
        if (window.innerWidth > 768 && heroSectionBottom < currentScrollPos) {
          document.getElementById('header').style.top = '-100px';

          if (currentScrollPos > 150) {
            oberservProductCard('up');
          }
        } else if (window.innerWidth <= 768) {
          document.getElementById('header').style.top = '-100px';
        }
      }

      prevScrollPos = currentScrollPos;
    };
  });
})();
/******/ })()
;